export default __webpack_public_path__ + "static/media/yesenia.75bfa9de.jpeg";